import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { HomeIcon } from 'lucide-react';

export default function Error404() {
    const navigate = useNavigate();

    useEffect(() => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className="min-h-screen bg-gradient-to-br from-primary/5 via-white to-secondary/10 flex items-center justify-center px-4 overflow-hidden relative">

            {/* Background blobs */}
            <div className="absolute inset-0 pointer-events-none overflow-hidden">
                <motion.div
                    className="absolute -top-32 -left-32 w-96 h-96 bg-primary/10 rounded-full blur-3xl"
                    animate={{ scale: [1, 1.15, 1], opacity: [0.5, 0.8, 0.5] }}
                    transition={{ duration: 8, repeat: Infinity, ease: 'easeInOut' }}
                />
                <motion.div
                    className="absolute -bottom-32 -right-32 w-96 h-96 bg-secondary/10 rounded-full blur-3xl"
                    animate={{ scale: [1.15, 1, 1.15], opacity: [0.8, 0.5, 0.8] }}
                    transition={{ duration: 8, repeat: Infinity, ease: 'easeInOut' }}
                />
            </div>

            <motion.div
                className="relative z-10 text-center flex flex-col items-center gap-6 max-w-lg"
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, ease: [0.25, 0.25, 0.25, 0.75] }}
            >
                {/* 404 number */}
                <motion.div
                    className="relative"
                    initial={{ scale: 0.7, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.8, ease: 'backOut', delay: 0.1 }}
                >
                    <span
                        className="text-[6rem] sm:text-[14rem] text-primary font-black leading-none select-none"
                        style={{
                        
                         
                            filter: 'drop-shadow(0 8px 32px rgba(14,165,233,0.18))',
                        }}
                    >
                        404
                    </span>
                  
                </motion.div>

                {/* Text */}
                <motion.div
                    className="space-y-3"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.35, duration: 0.6 }}
                >
                    <h1 className="text-2xl sm:text-3xl font-bold text-gray-700">
                        Page Not Found
                    </h1>
                    <p className="text-gray-500 text-base sm:text-lg leading-relaxed max-w-sm mx-auto">
                        The page you're looking for doesn't exist or may have been moved.
                    </p>
                </motion.div>

                {/* Divider pulse line */}
                <motion.div
                    className="w-16 h-1 rounded-full bg-gradient-to-r from-primary to-secondary"
                    initial={{ scaleX: 0 }}
                    animate={{ scaleX: 1 }}
                    transition={{ delay: 0.5, duration: 0.5 }}
                />

                {/* Back to Home button */}
                <motion.button
                    onClick={() => navigate('/')}
                    className="mt-2 flex items-center gap-3 px-8 py-4 rounded-2xl font-bold bg-primary text-white text-base shadow-xl transition-all duration-300"
                    style={{
                        boxShadow: '0 8px 32px rgba(14,165,233,0.30)',
                    }}
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6, duration: 0.5 }}
                    whileHover={{ scale: 1.05, y: -2 }}
                    whileTap={{ scale: 0.97 }}
                >
                    <HomeIcon/>
                    Back to Home
                </motion.button>
            </motion.div>
        </div>
    );
}